import {
  useGetQrStatsByCodeQuery,
  useGetQrStatsQuery,
} from "../../features/api/qrApiSlice";
import "./QrStats.scss";

const qrCards = [
  {
    label: "Mini YouTube",
    code: "mini-youtube",
    vehicle: "Mini Cooper",
    platform: "YouTube",
  },
  {
    label: "Mini TikTok",
    code: "mini-tiktok",
    vehicle: "Mini Cooper",
    platform: "TikTok",
  },
  {
    label: "Mini Facebook",
    code: "mini-facebook",
    vehicle: "Mini Cooper",
    platform: "Facebook",
  },
  {
    label: "Sonata YouTube",
    code: "sonata-youtube",
    vehicle: "Hyundai Sonata",
    platform: "YouTube",
  },
  {
    label: "Sonata TikTok",
    code: "sonata-tiktok",
    vehicle: "Hyundai Sonata",
    platform: "TikTok",
  },
  {
    label: "Sonata Facebook",
    code: "sonata-facebook",
    vehicle: "Hyundai Sonata",
    platform: "Facebook",
  },
];

function QrStatCard({ label, vehicle, platform, data }) {
  return (
    <article className="qr-stat-card">
      <div className="qr-stat-card__top">
        <div>
          <h3>{label}</h3>
          <p>
            {vehicle} · {platform}
          </p>
        </div>
      </div>

      <div className="qr-stat-card__number">{data?.totalScans || 0}</div>

      <div className="qr-stat-card__rows">
        <span>Today: {data?.today || 0}</span>
        <span>This Week: {data?.thisWeek || 0}</span>
        <span>This Month: {data?.thisMonth || 0}</span>
      </div>
    </article>
  );
}

function QrVehicleSection({ title, cards }) {
  return (
    <div className="qr-stats__group">
      <h2>{title}</h2>

      <div className="qr-stats__grid">
        {cards.map((card) => (
          <QrStatsCardLoader key={card.code} card={card} />
        ))}
      </div>
    </div>
  );
}

function QrStatsCardLoader({ card }) {
  const { data, isLoading } = useGetQrStatsByCodeQuery(card.code);

  return (
    <QrStatCard
      label={card.label}
      vehicle={card.vehicle}
      platform={card.platform}
      data={isLoading ? null : data}
    />
  );
}

export default function QrStats() {
  const { data: allStats, isLoading: allLoading } = useGetQrStatsQuery();

  const miniCards = qrCards.filter((card) => card.vehicle === "Mini Cooper");
  const sonataCards = qrCards.filter(
    (card) => card.vehicle === "Hyundai Sonata"
  );

  if (allLoading) return <p>Loading QR stats...</p>;

  return (
    <section className="qr-stats">
      <div className="qr-stats__header">
        <div>
          <h1>QR Code Stats</h1>
          <p>Track QR scans by vehicle and platform.</p>
        </div>

        <article className="qr-stats__summary">
          <span style={{ marginRight: "10px" }}>Total Scans</span>
          <strong>{allStats?.totalScans || 0}</strong>
        </article>
      </div>

      <QrVehicleSection title="Mini Cooper" cards={miniCards} />
      <QrVehicleSection title="Hyundai Sonata" cards={sonataCards} />
    </section>
  );
}
